import React from "react";
import AppRouter from "./router/Approuter";
import { GlobalStyle } from "./utils/styles";
import { ApolloProvider } from "@apollo/react-hooks";
import ApolloClient from "apollo-boost";
import ContextProvider from "./utils/Context/Context";

// color: rgb(0, 204, 255);

const client = new ApolloClient({
  // uri: "http://localhost:443",
  uri: "https://z1puyl5f7c.execute-api.us-east-1.amazonaws.com/dev/graphql",
});

function App() {
  return (
    <ApolloProvider client={client}>
      <ContextProvider>
        <AppRouter />
        <GlobalStyle />
      </ContextProvider>
    </ApolloProvider>
  );
}

export default App;
